import Generating from "@/component/Generating";
import AITipTool from "../AITipTool";
import "./index.less";
import { ChatMessage, MessageSource, MessageStatus, MessageType } from "@/services/api_question";
import ChatStore from "@/store/chat.store";
// import { Fragment, useEffect, useRef } from "react";
import { Fragment, useEffect, useRef } from "react";

interface AIChatContent {
  content: ChatMessage[];
  onChange: (v: string) => void;
  onConfirm: (v: string, source: MessageSource) => void;
}

const AIChatContent = (props: AIChatContent) => {
  const { content, onChange, onConfirm } = props;
  const isGenerating = ChatStore((state) => state.isGenerating);
  const assiociationWords = ChatStore((state) => state.assiociationWords);
  const latestMessage = ChatStore((state) => state.latestMessage);
  const contentRef = useRef<HTMLDivElement>(null);
  const listenRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      if (!entries[0].isIntersecting) {
        listenRef.current?.scrollIntoView({ behavior: "smooth" });
      }
    },{
      threshold: 0.7,
    });
    if (listenRef.current) {
      observer.observe(listenRef.current);
    }
    return () => {
      observer.disconnect();
    };
  }, []);

  const checkIsLastReply = (message: ChatMessage) => {
    if (latestMessage?.id === message.id) {
      return true;
    }
    if (latestMessage) {
      return false;
    }
    const reply = content.filter((item) => item.messageType === MessageType.ANSWER);
    return reply[reply.length - 1]?.id === message.id;
  };

  const checkShowTool = (message: ChatMessage) => {
    if (checkIsLastReply(message) && !isGenerating) {
      return true;
    } else if (!checkIsLastReply(message)) {
      return true;
    }
    return false;
  };

  const checkHasAssociationWord = (message: ChatMessage) => {
    return message.associationWord?.length || 0 > 0;
  };

  const getAssociationWords = (message: ChatMessage) => {
    return assiociationWords.length > 0 ? assiociationWords : message.associationWord || [];
  };

  const handleClickAssiociationWord = (word: string) => {
    onChange(word);
    onConfirm(word, MessageSource.ASSOCIATION);
  };

  return (
    <div className="AIChatContent" ref={contentRef}>
      {content.map((item) => {
        return (
          <Fragment key={item.id}>
            {item.messageType === MessageType.QUESTION && <div className={`content-item right chat-item`}>{item.message}</div>}
            {item.messageType === MessageType.ANSWER && item.messageStatus !== MessageStatus.REVOKE && (
              <>
                <div className={`generate reply ${checkIsLastReply(item) ? "last" : "not-last"}`}>
                  <div className={`content-item left chat-item`}>
                    <span>{item.message}</span>
                    {/* {checkIsLastReply(item) && isGenerating && (
                      <div className="inline-block ml-2">
                        <Generating />
                      </div>
                    )} */}
                  </div>
                  {checkShowTool(item) && <AITipTool message={item} showRegenrate={checkIsLastReply(item)} />}
                </div>
                {checkIsLastReply(item) && !isGenerating && (assiociationWords.length > 0 || checkHasAssociationWord(item)) && (
                  <div className="mt-8">
                    {getAssociationWords(item).map((word) => {
                      return (
                        <div
                          className="content-item left tip-item"
                          key={word}
                          onClick={() => {
                            handleClickAssiociationWord(word);
                          }}
                        >
                          {word}
                        </div>
                      );
                    })}
                  </div>
                )}
              </>
            )}
          </Fragment>
        );
      })}
      <>
        {latestMessage && (
          <>
            <div className="generate reply">
              <div className={`block content-item left chat-item`}>
                <span>{latestMessage?.message}</span>
                {checkIsLastReply(latestMessage) && isGenerating && (
                  <div className="inline-block ml-2">
                    <Generating />
                  </div>
                )}
              </div>
            </div>
          </>
        )}
      </>
      {/* 用于滚动到底部 */}
      <div ref={listenRef} className="absolute w-1 h-5 bottom-0">
        {""}
      </div>
    </div>
  );
};

export default AIChatContent;
